import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  formatValue,
  // formatChange,
  formatTimestamp,
} from './widgetUtils';

import widgetWrapper from './widgetWrapper';

import './NumberWidget.scss';

class NumberWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    details: PropTypes.string,
    value: PropTypes.number.isRequired,
    previous: PropTypes.number,
    format: PropTypes.string,
    smallFormat: PropTypes.string,
    hideChangeValue: PropTypes.bool,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    details: '',
    previous: Number.NaN,
    format: '.3s',
    smallFormat: '.2f',
    hideChangeValue: false,
    timestamp: '',
    className: '',
  };

  render() {

    const {
      title,
      subtitle,
      details,
      value,
      // previous,
      format,
      smallFormat,
      hideChangeValue,
      timestamp,
      className,
    } = this.props;

    /* eslint-disable no-nested-ternary */
    return (
      <div className={`NumberWidget ${className} widget-threshold-colors pdf-colors`}>
        <div className="header">
          <div className="title">{title}</div>
          {
            subtitle ? <div className="subtitle">{subtitle}</div> : ''
          }
        </div>
        <div className="content">
          <div className="value">{Number.isNaN(value) ? '' : formatValue(value, format, smallFormat)}</div>
          {
            hideChangeValue
              ? ''
              : (
                <div className="change">
                  {/*{
                    (Number.isNaN(value) || Number.isNaN(previous))
                      ? '-'
                      : formatChange(value, previous, hideChangeValue)
                  }*/}
                </div>
              )
          }
        </div>
        <div className="footer">
          {
            details ? <div className="details">{details}</div> : ''
          }
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
    /* eslint-disable no-nested-ternary */
  }
}

export default widgetWrapper(NumberWidget);
